import _ from "lodash";

import React from "react";
import {
  withLocation,
} from "CommonCore/router-util";

import store from "CommonState/store";

export default function uiconfig(Component) {
  @store("uiconfig")
  class ConfigChecker extends React.Component {
    isEnabled = right => {
      const { uiconfig } = this.props;
      return uiconfig && uiconfig[right];
    };

    ifAllowed = (right, value) => {
      if (this.isEnabled(right)) {
        return value;
      }
    };

    render() {
      return <Component
        ifAllowed={this.ifAllowed}
        ifEntityAllows={allows}
        {...this.props}/>;
    }
  }

  return ConfigChecker;
}

export function allows(entity, right, value) {
  if (entity && entity.zugriff && entity.zugriff[right]) {
    return value;
  }
}

export function ifValidEntity(prop) {
  return Component => {
    @withLocation
    class ValidEntityChecker extends React.Component {
      componentDidMount() {
        this.check(this.props);
      }

      componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
          this.check(this.props);
        }
      }

      check(props) {
        const history = props.history;
        const entity = props[prop];
        if (entity instanceof Error) {
          console.log(`Invalid entity ${ prop }, redirecting to /`);
          history.replace("/");
        }
      }

      render() {
        return <Component {...this.props}/>;
      }
    }
    return ValidEntityChecker;
  };
}

export function ifAllowed(requiredRight, skipCheckF, opts) {
  if (_.isPlainObject(skipCheckF) && !opts) {
    opts = skipCheckF;
    skipCheckF = void 0;
  }

  return Component => {
    @withLocation
    @store("uiconfig")
    class AllowedChecker extends React.Component {
      // KI claud.ai: State für Redirect-Tracking: Verhindert mehrfaches Redirecten.
      constructor(props) {
        super(props);
        this.state = { checked: false };
      }

      componentDidMount() {
        this.check(this.props);
      }

      componentDidUpdate(prevProps) {
        // KI claude.ai: Nur checken wenn sich relevante Props geändert haben
        if (prevProps.uiconfig !== this.props.uiconfig) {
          this.check(this.props);
        }
      }

      check(props) {
        const { history, uiconfig } = props;
        const shouldDisallow = uiconfig && (!skipCheckF || !skipCheckF(props)) && !uiconfig[requiredRight];

        if (shouldDisallow && (!opts || opts.redirect !== false)) {
          if (!uiconfig[requiredRight]) {
            console.error(`AllowedChecker: uiconfig is missing ${ requiredRight }: check name`);
          }
          // KI claude.ai: Nur einmal redirecten
          if (!this.state.checked) {
            this.setState({ checked: true });
            // KI claude.ai: Navigation im Callback nach setState
            setTimeout(() => {
              history.replace("/");
            }, 0);
          }
        }
        this._disallow = shouldDisallow;
      }

      render() {
        return this._disallow ? null : <Component {...this.props}/>;
      }
    }
    return AllowedChecker;
  };
}

export function ifEntityAllows(prop, requiredRight) {
  return Component => {
    @withLocation
    class EntityAllowsChecker extends React.Component {
      componentDidMount() {
        this.check(this.props);
      }

      componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
          this.check(this.props);
        }
      }

      check(props) {
        const history = props.history;
        const entity = props[prop];
        if (entity && entity.zugriff && !entity.zugriff[requiredRight]) {
          history.replace("/");
        }
      }

      render() {
        return <Component {...this.props}/>;
      }
    }
    return EntityAllowsChecker;
  };
}

export function stagger(ms) {
  return Component => {
    class Staggered extends React.Component {
      constructor() {
        super();
        this.state = {};
      }

      componentDidMount() {
        this.token = setTimeout(() => {
          this.setState({ go: true });
          this.token = null;
        }, ms);
      }

      componentWillUnmount() {
        if (this.token) {
          clearTimeout(this.token);
          this.token = null;
        }
      }

      render() {
        return this.state.go ? <Component {...this.props}/> : null;
      }
    }

    return Staggered;
  };
}

export function decorateIfAllows(decorator, right) {
  return Component => {
    const WrappedComponent = decorator(Component);
    return uiconfig(props => props.uiconfig && props.uiconfig[right] ? <WrappedComponent {...props}/> : <Component {...props}/>);
  };
}
